import { computeQuote } from "api/feature/quoterApi";

// Revalida un plan favorito contra `/rate-engine/compute` en vez de diffearlo
// a mano contra el catálogo de beneficios vigente (como hacía la versión
// anterior de este archivo, `FavoritePlanStaleness.js`). Confirmado con
// backend/QA: un 400 del rate engine significa que algún beneficio
// seleccionado ya no existe en el catálogo, así que alcanza con mirar si el
// compute falla - no hace falta traer el catálogo al front para compararlo.
//
// A diferencia de la versión anterior, esto no sanea el estado (no hay forma
// de saber, a partir de un 400 genérico, qué campo puntual quedó inválido):
// si el plan ya no es cotizable, se avisa y no se lo usa/edita tal cual está.

/**
 * @param {object} planData  El `data` guardado del plan favorito (= request de
 *   `/rate-engine/compute`, ver helpers/FavoritePlanToQuote.js).
 * @returns {Promise<boolean>} true si el plan ya no es cotizable tal cual está.
 */
export const isFavoritePlanStale = async (planData) => {
    try {
        await computeQuote(planData);
        return false;
    } catch (error) {
        console.error('Error validating favorite plan:', error?.response?.data?.message ?? error.message);
        return true;
    }
};

export default isFavoritePlanStale;
